export const LANGUAGE_CODE = {
  ID: 'ID',
  EN: 'EN',
};

export const LANGUAGE_VALUE = {
  ID: 'id',
  EN: 'en',
};
